import React, { useState } from "react";
import { Paper, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ICONS } from "./../Icons";

function ServiceControl({ label, type, onCallbackClick }) {
  const [isDisabled, setIsDisabled] = useState(false)
  const [bgColor, setBgColor] = useState("#fff")
  
  const handleClick = function () {
    const disable = !isDisabled
    setIsDisabled(disable)
    setBgColor(disable === true ? "#E9E9E9" : "#fff")
    onCallbackClick(type, disable)
  };

  const ControlPaper = styled(Paper)(({ theme }) => ({
    width: "140px",
    height: "fit-content",
    display: "inline-flex",
    borderRadius: "10px",
    padding: 8,
    gap: 8,
    ...theme.typography.body2,
    textAlign: "left",
    alignItems: "center",
    cursor: "pointer"
  }))

  return (
    <ControlPaper key={type} elevation={0} onClick={handleClick} sx={{
      backgroundColor: bgColor
    }}>
      <img
        src={isDisabled ? ICONS.get(type).disable : ICONS.get(type).fill}
        alt={label}
        width="42px"
        height="42px"
      />
      <Typography
        variant="h6"
        sx={{
          margin: "4px",
          color: "#323232",
          fontStyle: "bold",
          fontFamily: "Poppins",
          fontSize: "12px",
        }}
      >
        {label}
      </Typography>
    </ControlPaper>
  );
}

export default ServiceControl;
